import { DateTime } from "luxon";

// Returns the user-TZ "start of day" for the given UTC ISO. This is the
// canonical "round to calendar day" used across positioning math and
// constraint arrows. The Gantt is a user-TZ scene end-to-end (architectural
// decision before Phase 2); callers pass their own user timezone.
function getDate(iso: string, userTimezone: string): DateTime {
  return DateTime.fromISO(iso, { zone: "utc" })
    .setZone(userTimezone)
    .startOf("day");
}

// Same conversion without the day snap — the daily view positions elements
// at their exact time-of-day. Every other view must keep using getDate.
function getPreciseDate(iso: string, userTimezone: string): DateTime {
  return DateTime.fromISO(iso, { zone: "utc" }).setZone(userTimezone);
}

export { getDate, getPreciseDate };
